import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import useAuth from '../../../../features/hooks/useAuth';
import BoReturnReqFlow from './BoReturnReqFlow'; // Flow visualization
import Bo_UnitHeadReturnInboxForm from './Bo_UnitHeadReturnInboxForm'; // Unit Head action form
import Bo_StoreReturnInboxForm from './Bo_StoreReturnInboxForm'; // Store action form
import Bo_UserTransferInboxForm from './Bo_UserTransferInboxForm'; // User action form
import { CommonButton } from '../../../../Styles/CommonStyles';
import Tooltip from '@mui/material/Tooltip';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import FilteredAssetsFetcher from '../../Myasset/FilteredAssetsFetcher'; // Fetch filtered assets



const Container = styled.div`
  padding: 20px;
`;
const ActionContainer = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 15px;
`;
const ButtonsWrapper = styled.div`
  display: flex;
  align-self: flex-start;
`;
const Button = styled(CommonButton)`
  padding: 8px 16px;
  min-width: 120px;
  margin-right: 10px;
`;
const SelectedAssetsContainer = styled.div`
  margin-top: 20px;
  width: 100%;
`;

const SelectedAssetsTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const SelectedAssetsTitle = styled.h3`
  margin-bottom: 0;
  color: #1976d2;
`;
const StyledTableContainer = styled(TableContainer)`
  margin-bottom: 20px;
`;
const ChipContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
// Add a new styled component for the single-line Asset Type cell
const SingleLineCell = styled(TableCell)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
`;
const StyledTableHead = styled(TableHead)`
  background-color: #1976d2;
  
  & th {
    color: white;
    font-weight: bold;
  }
`;

const BoAsstRtrnReqDetails = ({row, setChangepage}) => {
  console.log("Entered")
  const [showActionOptions, setShowActionOptions] = useState(false);
  const [assetSummary, setAssetSummary] = useState([]);  
  const [filteredAssets, setFilteredAssets] = useState([]);
  
  const { id: userId, roles } = useAuth();
  const user_current_office = useSelector((state) => state.office.off);
  const user_current_role_array = roles[user_current_office] || [];

  // Helper function to check if this request is for the current user to action
  const isRequestForUser = () => {
    const lastAction = row?.req_data?.[row.req_data.length - 1];
    if (!lastAction) return false;
    
    return lastAction.sent_to?.id === userId;
  };


  // Check if the request was closed or rejected
  const isRequestClosedOrRejected = 
    row?.curr_status === 'Closed' || 
    row?.curr_status === 'Rejected' ||
    row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'bo_return_req_rejected' ||
    row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'store_return_rejected' ||
    row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'botostore_return_req_rejected' ||
    row?.req_data?.[row.req_data.length - 1]?.sent_to_tag === 'store_return_approved';
  
  const handleTakeAction = () => {
    setShowActionOptions(true);
  }

  const handleBack = () => {
    setChangepage([true, false, false, false, false]);
  };

  useEffect(() => {
    if (filteredAssets) {
      console.log(filteredAssets?.assets)
      console.log(groupAssetsByName(filteredAssets?.assets))
      setAssetSummary(groupAssetsByName(filteredAssets?.assets));
    }
  }, [filteredAssets]);

  function groupAssetsByName(assets) {
    const grouped = {};
  
    assets?.forEach((asset) => {
      const name = asset.name || "Unknown";
  
      if (!grouped[name]) {
        grouped[name] = [];
      }
  
      grouped[name].push(asset);
    });
  
    return Object.entries(grouped).map(([name, assets]) => ({
      name,
      count: assets.length,
      assets,
    }));
  }

  // Determine which form to show based on current status and user role
  const renderInboxForm = () => {
    const isUnitHead = user_current_role_array.includes('UnitHead');
    const isStoreApprover = user_current_role_array.includes('L1ReqApprover_A');
    const isReceivingUser = row.curr_sent_to === userId;

    console.log("User Roles: ", user_current_role_array);

    console.log(isUnitHead, isStoreApprover, isReceivingUser)
    console.log(isRequestClosedOrRejected, isRequestForUser(), showActionOptions)

    switch (row.curr_sent_to_tag) {
      // BO requests return to store -> Sent to Unit Head
      case 'bo_store_return_created': 
        if (isUnitHead && isReceivingUser) {
          return <Bo_UnitHeadReturnInboxForm row={row} showActionOptions={showActionOptions} handleBack={handleBack} />;
        }
        break;
      
      // Unit Head approved return -> Sent to Store L1 Approver
      case 'botostore_return_req_forwarded':
        if (isStoreApprover && isReceivingUser) {
          return <Bo_StoreReturnInboxForm row={row} showActionOptions={showActionOptions} handleBack={handleBack} />;
        }
        break;

      // BO requests transfer to user via Unit Head -> Sent to Unit Head for approval
      case 'bo_user_transfer_unithead_approval':
        if (isUnitHead && isReceivingUser) {
          return <Bo_UnitHeadReturnInboxForm row={row} showActionOptions={showActionOptions} handleBack={handleBack} />;
        }
        break;

      // BO requests transfer to user -> Sent to User (after Unit Head approval)
      case 'new_bo_transfer_req':
      case 'uh_apprvd_bo_user_transfer':
        if (isReceivingUser) {
          return <Bo_UserTransferInboxForm row={row} showActionOptions={showActionOptions} handleBack={handleBack} />;
        }
        break;

      // Add other cases if needed for rejected flows etc.

      default:
        return null; // No form needed or request is closed/rejected
    }
    return null; // Fallback if user role doesn't match expected assignee
  };

  return (
    
    <Container>
      <FilteredAssetsFetcher filters={{perm_ids:[row.assets_requested[row.assets_requested.length - 1]?.data.map( x=> x.id)]}} onDataFetched={setFilteredAssets} />

      {/* Always show the request flow/details */}
      <BoReturnReqFlow row={row} />
      <ActionContainer>
        {!showActionOptions ? (
          <ButtonsWrapper>
            {/* Don't show Take Action button if the request was rejected or closed,
                or if the request is not meant for this user */}
            {!isRequestClosedOrRejected && isRequestForUser() && (
              <Button onClick={handleTakeAction}>Take Action</Button>
            )}
          </ButtonsWrapper>
        ) : (
          <>
            {/* Show Assets to be Returned table only after clicking Take Action */}
            <SelectedAssetsContainer>
              <SelectedAssetsTitleContainer>
                <SelectedAssetsTitle>
                  Assets to be Returned
                </SelectedAssetsTitle>
                <div>                  
                  <Tooltip title="Print Assets List">
                  </Tooltip>
                </div>
              </SelectedAssetsTitleContainer>
              
                <StyledTableContainer component={Paper}>
                  <Table aria-label="selected assets table">
                    <StyledTableHead>
                      <TableRow>
                        <TableCell width="50px">Sl.No</TableCell>
                        <TableCell>Asset Type</TableCell>
                        <TableCell align="center">Quantity</TableCell>
                        <TableCell>Asset Tags</TableCell>
                      </TableRow>
                    </StyledTableHead>
                    <TableBody>
                      {assetSummary?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <SingleLineCell title={item.name}>{item.name}</SingleLineCell>
                          <TableCell align="center">{item.count}</TableCell>
                          <TableCell>
                            <ChipContainer>
                              {item?.assets?.map((asset, i) => (
                                <Chip
                                  key={i}
                                  label={asset.oem_tag || '-'}
                                  color="primary"
                                  variant="outlined"
                                  size="small"
                                />
                              ))}
                            </ChipContainer>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </StyledTableContainer>              
            </SelectedAssetsContainer>
          </>
        )}
      </ActionContainer>

      {/* Conditionally render the appropriate inbox form */}
      {renderInboxForm()}
    </Container>
  );
};

export default BoAsstRtrnReqDetails; 